// react and js
import * as React from "react";
import { useTranslation } from "react-i18next";

// mui
import { styled } from "@mui/material/styles";

// components
import Page from "../../components/Page";

// hooks

// layouts

// pages

// theme

// utils

// widgets
import WidgetDistributionTickData from "../../widgets/distribution_tick_data/DistributionTickData";

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------
const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex",
  },
}));

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export default function StartTickDataDistribution() {
  const { t } = useTranslation();
  return (
    <Page title={t("pages.distributionTickData.pageTitle")}>
      <RootStyle>
        <WidgetDistributionTickData />
      </RootStyle>
    </Page>
  );
}
